import { render } from "./accordionItemComponent.vue?vue&type=template&id=2fcb64c2&scoped=true"
import script from "./accordionItemComponent.vue?vue&type=script&lang=js"
export * from "./accordionItemComponent.vue?vue&type=script&lang=js"

import "./accordionItemComponent.vue?vue&type=style&index=0&id=2fcb64c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcb64c2"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/accordion/accordionItemComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fcb64c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fcb64c2', __exports__)) {
    api.reload('2fcb64c2', __exports__)
  }
  
  module.hot.accept("./accordionItemComponent.vue?vue&type=template&id=2fcb64c2&scoped=true", () => {
    api.rerender('2fcb64c2', render)
  })

}


export default __exports__